import React from 'react';
import styled from 'styled-components';
import { Color, Grid, Type } from '../../app/StyleGuide';

type FeedbackStatus = 'complete' | 'in_progress' | 'not_started' | string | undefined;

type FeedbackStatusBadgeProps = {
  status?: FeedbackStatus;
  label: string;
  className?: string;
};

const Badge = styled.span<{ $status?: FeedbackStatus }>`
  display: inline-flex;
  align-items: center;
  gap: ${Grid._2};
  padding: ${Grid._2} ${Grid._4};
  border-radius: 999px;
  font-size: ${Type.Scale._1};
  font-weight: ${Type.Weight.semibold};
  color: ${({ $status }) =>
    $status === 'complete' ? Color.Primary._70 : $status === 'in_progress' ? '#8a5a00' : Color.Gray._80};
  background: ${({ $status }) =>
    $status === 'complete' ? Color.Primary._05 : $status === 'in_progress' ? '#fff3cd' : Color.Gray._10};
  border: 1px solid
    ${({ $status }) =>
      $status === 'complete' ? Color.Primary._10 : $status === 'in_progress' ? '#f5d58a' : Color.Gray._20};
`;

export default function FeedbackStatusBadge({ status, label, className }: FeedbackStatusBadgeProps) {
  return (
    <Badge $status={status} className={className}>
      {label}
    </Badge>
  );
}
